import { Link } from "react-router-dom";
import CartItemTable from "../../../../components/CartItemTable/CartItemTable";
import { StyledButton } from "../../../../components/styled/styled-components";
import { OrderSplitAPIResponse, PaymentMethods } from "../../../../interfaces/interfaces";
import {
  getPaymentDetails,
  PaymentDetailsId,
  IDetail,
} from "../../../../utils/OrderPaymentDetails";
import { Context, IContext } from "../../../../context/ContextApp";
import { useContext } from "react";
import { subdomainTypes } from "../../../../context/availableSubdomains";

interface Props {
  splitAPIResponse: OrderSplitAPIResponse;
  isOrderAvailableToCCPayment: boolean;
}

const CartInformation = ({ splitAPIResponse, isOrderAvailableToCCPayment }: Props) => {
  const { appBranch }: IContext = useContext(Context);
  const paymentDetails = getPaymentDetails(splitAPIResponse.current_order, appBranch);

  const isEnablePaymentLink = (paymentDetail: IDetail) => {
    if (!isOrderAvailableToCCPayment) {
      return false;
    }
    const isTransactionFee = paymentDetail.id === PaymentDetailsId.transactionFee;
    const isBankTransferAndSubtotal =
      splitAPIResponse.current_order.payment_method === PaymentMethods.BankTransfer &&
      paymentDetail.id === PaymentDetailsId.grandTotal;
    return isTransactionFee || isBankTransferAndSubtotal;
  };

  const isOnlinePayment = splitAPIResponse.current_order.payment_method === PaymentMethods.Online;

  return (
    <div className="cart-information">
      <div className="order-list">
        <CartItemTable items={splitAPIResponse.current_order.order_items} bo split checkout />
        <div role="group" className="final-row">
          <Link replace to="/store/cart">
            <StyledButton>Edit cart</StyledButton>
          </Link>
          <table className="total-costs">
            <tbody>
              {paymentDetails.map((paymentDetail) => (
                <tr key={`paymentDetail_${paymentDetail.title}`}>
                  {isEnablePaymentLink(paymentDetail) ? (
                    <th>
                      <Link replace to="/check-out/payment-selection">
                        Edit Payment Method
                      </Link>
                    </th>
                  ) : (
                    <th />
                  )}

                  <th role="rowheader">
                    {paymentDetail.boldTitle ? <b>{paymentDetail.title}</b> : paymentDetail.title}:
                  </th>
                  <td role="cell">{paymentDetail.value}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {isOnlinePayment && appBranch === subdomainTypes.NZ && (
          <div className="payment-info">
            <strong>NOTE:</strong> Merchant Service Fee will be calculated and added on the
            following page, prior to payment confirmation.
          </div>
        )}
      </div>
    </div>
  );
};

export default CartInformation;
